const testimonials = [
  {
    id: 1,
    img: "/assets/img/testimonial/testi_2_1.jpg",
    name: "David Farnandes",
    role: "CEO at Anaton",
    text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration.",
  },
  {
    id: 2,
    img: "/assets/img/testimonial/testi_2_2.jpg",
    name: "Jackline Techie",
    role: "CEO at Kormola",
    text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration.",
  },
  {
    id: 3,
    img: "/assets/img/testimonial/testi_2_3.jpg",
    name: "Abraham Khalil",
    role: "CEO at Rimasu",
    text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration.",
  },
  {
    id: 4,
    img: "/assets/img/testimonial/testi_3_4.jpg",
    name: "Md Sumon Mia",
    role: "CEO at Rimasu",
    text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration.",
  },
];

export default testimonials;
